<template>
	<div class="photo-detail" v-if="end && !mipLinkLoading">
		<div class="top">
			<div class="detail-box-bg" v-if="imgurl != ''">
				<img v-setshow :src="imgurl" alt="" />
				<div class="bottom-bg">

				</div>
			</div>
			<div class="detail-box-panel" :class="{ 'have-img': imgurl != '' }">
				<div class="detail-box">
					<div class="detail-box-txt0">
						<div class="p1">{{ infos.title }}</div>
						<div class="p2">
							<span v-if="infos.majorName">{{ infos.majorName }}</span>
							<span v-if="infos.groupName">{{ infos.groupName }}</span>
						</div>
						<div class="p3">
							<div class="item1">
								<img src="../../assets/images/active/icon_adress.png" alt="" />
								{{ infos.organization || "暂无报名服务单位" }}
							</div>
							<div class="item2">
								<img src="../../assets/images/active/icon_time.png" alt="" />
								{{ infos.time }}
							</div>
						</div>
						<div class="p4">
							<div class="idTab-time" v-if="infos.img && infos.img.length > 0">
								<div class="idTab" v-for="(ks, index) in infos.img" :key="index">
									<div class="overallBetween idTab-div">
										<div class="fileName">
											{{ getfileTypeName(ks.fileType)}} | {{ ks.fileName }}
										</div>
										<a @click.stop="getcheck(ks)">查看></a>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
				<div class="detail-box">
					<div class="detail-box-title">
						<img src="../../assets/images/active/icon_label.png" alt="" /> 作品简介
					</div>
					<div class="detail-box-txt1">
						<div>{{ infos.slogan }}</div>
					</div>
				</div>
				<div class="detail-box">
					<div class="detail-box-title">
						<img src="../../assets/images/active/icon_rili.png" alt="" /> 参赛日程
					</div>
					<div class="detail-box-txt2">
						<div v-for="(item, index) in scheduleList" :key="index" class="list">
							<div class="p1">
								<img src="../../assets/images/active/icon_chenggong.png" alt="" />
							</div>
							<div class="p2">
								{{ item.content }}
							</div>
							<div class="p3">
								{{ item.time }}
							</div>
							<!-- 无效参赛结果下显示评语 -->
							<div class="p4" v-if="item.content=='无效参赛'&&item.comment">
								<span class="comment-label">评语：</span>{{ item.comment }}
							</div>
						</div>
					</div>
				</div>

				<!-- 学生艺术综合素养能力画像 -->
				<div class="detail-box" v-if="abilityProfileData && abilityProfileData.scores && abilityProfileData.scores.length">
					<div class="ability-profile" ref="abilityProfile">
						<div class="ap-header">
							<div class="ap-icon"></div>
							<div class="ap-title">学生艺术综合素养能力画像</div>
						</div>
						<div class="ap-chart" ref="radarChart"></div>
						<div class="ap-recommend" v-if="abilityProfileData.recommendCareerPath">
							推荐方向: {{ abilityProfileData.recommendCareerPath }}
						</div>
						<div class="ap-save" @click="saveAbilityImage">↓ 保存图片</div>
						<!-- 本次活动能力增长 -->
						<div class="ap-growth" v-if="abilityProfileData.scoresChange && abilityProfileData.scoresChange.length">
							<div class="ap-growth-title">本次活动能力增长</div>
							<div class="ap-growth-list">
								<div class="ap-growth-item" v-for="(g, i) in abilityProfileData.scoresChange" :key="'g'+i">
									<span class="ap-growth-name">{{ g.optionName }}</span>
									<span class="ap-growth-val">+{{ g.score }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="detail-box">
					<div class="detail-box-title">
						<img src="../../assets/images/active/icon_baomingxinxi.png" alt="" /> 报名信息
					</div>
					<div class="detail-box-txt3">
						<div class="list">
							<div class="p2">
								作品编号
							</div>
							<div class="p3">
								{{ infos.transactionId }}
							</div>
						</div>
						<div class="list">
							<div class="p2">
								作者姓名
							</div>
							<div class="p3">
								{{ infos.author }}
							</div>
						</div>
					</div>
				</div>
				<div class="detail-box diy-cert-box" v-if="imgurl&&certificate&&infos.diyCertStatus!=0">
					<div class="detail-box-title">
						<img src="../../assets/images/active/icon_label.png" alt="" /> 个性化服务
					</div>
					<div class="detail-box-diy" @click="goToDIY">
						<div class="diy-icon">
							<span class="iconfont-like"></span>
						</div>
						<div class="diy-text">
							<div class="diy-title">DIY 证书</div>
							<div class="diy-desc">{{infos.diyCertStatus==1?'点击自定义您的专属获奖证书':'您已自定义过证书，点击查看'}}</div>
						</div>
						<div class="diy-arrow">›</div>
					</div>
				</div>
			</div>
		</div>
		<div class="page-wrap" v-if="end && !mipLinkLoading">
			<div class="reason" v-if="infos.grandPrize && infos.achievementType == 2">
				<div class="reason-tips"></div>
				<SignTitle title="推荐理由" :simplicity="true" />
				<div class="reason-content">
					{{ infos.recommendReason }}
				</div>
			</div>
		</div>
		<van-overlay :show="!end || mipLinkLoading">
			<van-loading size="24px" color="#fff">加载中...</van-loading>
		</van-overlay>
		<van-popup v-model="checkType" class="photo-tags" closeable position="bottom"
			:style="{ height: '100%', width: '100%' }" @close="beforeCloseHandler(checkData.fileType)">
			<div class="show-photo-tags">
				<img v-if="checkData.fileType == 1" :src="checkData.fileUrl" alt="" />
				<audio ref="audioPlayer" v-if="checkData.fileType == 2" width="100%" height="200" controls
					:src="checkData.fileUrl"></audio>
				<video ref="videoPlayer" v-if="checkData.fileType == 3" width="100%" height="200" controls
					:src="checkData.fileUrl"></video>
				<p style="text-align: center; margin-top: 20px" v-if="checkData.fileType == 5">
					<a style="font-size: 18px; color: #16d77a"  :href="checkData.fileUrl">
						点击下载压缩文件作品
					</a>
				</p>
				<p style="text-align: center; margin-top: 20px" v-if="checkData.fileType == 4">
					<a style="font-size: 18px; color: #16d77a"  :href="checkData.fileUrl">
						点击查看文档类作品
					</a>
				</p>
			</div>
		</van-popup>


		<van-dialog v-model="sendEmail" title="是否愿意体验《学与玩》电子刊" show-cancel-button show-confirm-button
			confirmButtonText="确定" cancelButtonText="我不需要" confirmButtonColor="#666" cancelButtonColor="#666"
			:before-close="holdBack" @confirm="sendEmailHandle" @cancel="sendEmailHandle(1)">
			<div class="tips-content">
				<p>{{ sendTips }}</p>
				<input class="email-inp" type="text" v-if="!hasEmail" v-model="inpEmail" />
			</div>
		</van-dialog>
		<van-popup v-model="DIYshow" class="photo-tags" closeable position="bottom"
			:style="{ height: '100%', width: '100%' }">
			<div class="show-photo-tags">
				<p>长按图片即可保存或分享</p>
				<img :src="DIYimages[0]" alt="" style="border-radius: 0px;"/>
			</div>
		</van-popup>
		<!-- <van-image-preview v-model="DIYshow" :images="DIYimages" @click="DIYshow = false">
			<template #cover>
				<div class="pre-close" style="text-align: right">
					<van-icon @click.stop="DIYshow = false" name="close" :style="{
						margin: '10px',
						fontSize: '24px',
						color: '#fff',
						position: 'fixed',
						left: '10px',
						right: '10px'
					}" />
				</div>
			</template>
		</van-image-preview> -->
	</div>
</template>

<script>
import SignTitle from "@/components/pub/SignTitle.vue";
import {
	formatNumber,
	getfileTypeArr,
	getfileTypeName
} from "@/utils/tool";
import StepBar from "@/components/mine/StepBar";
import {
	signature
} from "@/utils/mixin/wx-js-sdk-signature";
import {
	validate
} from "@/utils/mixin/validate";
import {
	getWorksDetails,
	getReleaseWorksDetails,
	AbilityProfile,
	getWorksCertificate,
	getCert
} from "@/utils/api/user";
import {
	sendReadingCode
} from "@/utils/api/home";
import {
	wxlogin
} from "@/utils/mixin/wxlogin";
import * as echarts from "echarts";
export default {
	mixins: [signature, wxlogin, validate],
	components: {
		// Sign,
		SignTitle,
		StepBar
	},
	computed: {
		canLikeHandel() {
			return (
				this.isVisitor &&
				this.role != 1 &&
				this.role != 2 &&
				this.role != 3 &&
				this.role != 0
			);
		},
		// 本次活动能力增长列表
		abilityGrowthList() {
			const scores = (this.abilityProfileData && this.abilityProfileData.scores) || [];
			return scores.map(s => ({
				name: s.optionName || '',
				score: Number(s.score) || 0
			}));
		},
		// 学生艺术综合素养能力画像 - ECharts 雷达图配置
		radarOption() {
			const scores = (this.abilityProfileData && this.abilityProfileData.scores) || [];
			const indicators = scores.map(s => ({
				name: s.optionName || '',
				max: 10
			}));
			const values = scores.map(s => Number(s.score) || 0);
			return {
				tooltip: {
					trigger: 'item'
				},
				radar: {
					indicator: indicators,
					radius: '62%',
					center: ['50%', '52%'],
					splitNumber: 5,
					axisName: {
						color: '#666666',
						fontSize: 13,
						padding: [4, 4]
					},
					splitArea: {
						areaStyle: {
							color: ['rgba(166,229,194,0.15)', 'rgba(255,255,255,0)']
						}
					},
					splitLine: {
						lineStyle: {
							color: '#A6E5C2'
						}
					},
					axisLine: {
						lineStyle: {
							color: '#A6E5C2'
						}
					}
				},
				series: [{
					type: 'radar',
					data: [{
						value: values,
						name: '能力画像',
						areaStyle: {
							color: 'rgba(52,199,123,0.35)'
						},
						lineStyle: {
							color: '#34C77B',
							width: 2
						},
						itemStyle: {
							color: '#34C77B'
						},
						label: {
							show: true,
							color: '#34C77B',
							fontSize: 14,
							fontWeight: 'bold',
							formatter: p => {
								// radar 顶点 label：value 可能是标量或数组，兼容处理
								const v = p.value;
								return Array.isArray(v) ? v[p.dimensionIndex || 0] : v;
							}
						}
					}]
				}]
			};
		}
	},
	data() {
		return {
			// 作品id
			id: null,
			// 当前角色
			role: -1,
			// 作品信息
			infos: {
				diyCertStatus:0
			},
			// 加载完成
			end: false,
			// 评论轮播
			swipeList: [],
			// 作品日程
			scheduleList: [],
			// 日程第几步
			step: -1,
			// DIY查看证书
			DIYshow: false,
			DIYimages:[],
			// 查看作品详情
			show: false,
			// 作品详情图
			images: [],
			// 设置分享朋友/qq、分享朋友圈/qq空间的分享内容,
			// 有问题
			jsApiList: ["scanQRCode", "updateAppMessageShareData", "updateTimelineShareData"],
			// 是否登录
			isLogin: true,
			// 展示内容
			content: "",
			// 跳转loading
			mipLinkLoading: false,
			// 是否游客
			isVisitor: true,
			hasEmail: false,
			sendEmail: false,
			sendTips: "",
			inpEmail: "",
			imgurl: '',
			certificate:'',
 
			checkType: false,
			checkData: {},
			abilityProfileData:{
				scores:[],
			}
		};
	},
	methods: {
		getfileTypeName,
		// 查看证书
		viewCcie(item) {
			getWorksCertificate(this.id).then((res) => {
				if (res.success) {
					if (res.data.certUrl) {
						this.certificate = res.data.certUrl;
					}
				}
			});
		},
		getcheck(ks) {
			this.checkData = ks;
			this.checkType = true;
		},
		// 跳转DIY证书页面
		goToDIY() {
			if (!this.infos) {
				this.$toast.fail('作品信息加载中，请稍后再试');
				return;
			}
			if(this.infos.diyCertStatus==1){
				const query = {
					id: this.$route.query.id,
					certificate: encodeURIComponent(this.certificate || ''),
					imgurl: encodeURIComponent(this.imgurl || ''),
					title: encodeURIComponent(this.infos.title || ''),
					desc: encodeURIComponent(this.infos.slogan || ''),
					author: encodeURIComponent(this.infos.author || '')
				};
				const qs = Object.keys(query).map(k => `${k}=${query[k]}`).join('&');
				this.$router.push(`/diy-cert?${qs}`);
			}else if(this.infos.diyCertStatus==2){
				getCert({"workId":this.id,"type": 3}).then((res) => {
					if (res.success) {
						if (res.data) {
                           	this.DIYimages = [res.data];
							this.DIYshow = true;
						} else {
							this.$toast.fail(res.message);
						}
					}
					this.$toast.clear()
				});
			}
		},
		getFileType(fileName) {
			return fileName.slice(-(fileName.length - fileName.lastIndexOf(".") - 1));
		},
		// 获取作品信息
		getPageDetail() {
			const user = this.$store.state.userInfo;
			if (JSON.stringify(user) !== "{}") {
				// 用户已登录
				getWorksDetails(this.id).then((res) => {
					if (res.success) {
						const d = res.data;
						this.sendTips = `报名服务单位已为您的学生${d.babyName}成功报名，请填写您的邮箱，稍后系统将发送一个《学与玩》电子刊免费阅读码到您的邮箱。`;
						let img = getfileTypeArr(d.imgs)
						for (let i in img) {
							if (img[i].fileType == 1) {
								this.imgurl = img[i].fileUrl
							}
						}
						this.infos = {
							mainBodyType:d.mainBodyType,
							activityType: d.activityType,
							prize: d.prize,
							head: d.babyInfo ? JSON.parse(d.babyInfo).imgUrl : "",
							img: img,
							transactionId: d.transactionId,
							achievementType: d.achievementType,
							title: d.name,
							slogan: d.synopsis,
							author: d.babyName,
							grandPrize: d.grandPrize,
							groupName: d.groupName,
							majorName: d.majorName,
							activityId:d.activityId,
							diyCertStatus:d.diyCertStatus,
							organization: d.institutionName || "个人报名",
							time: d.addTime,
							activityName: d.activityName,
							province: d.province,
							email: d.email,
							likers: formatNumber(d.likeNum),
							recommendReason: d.recommendReason,
						};
						this.viewCcie(this.infos)
						const role = this.$store.state.role;
						if (d.swCommentsWorksList&&swCommentsWorksList.length>0) {
							this.swipeList = d.swCommentsWorksList.map((e) => {
								return {
									content: e.comment,
									score: e.fraction
								};
							});
						}
						this.setScheduleList(d);
						this.end = true;
						this.shareReady();
					}
				});
			} else {
				// 用户未登录
				getReleaseWorksDetails({
					id: this.id
				}).then((res) => {
					if (res.success) {
						const d = res.data;
						let img = getfileTypeArr(d.imgs)
						for (let i in img) {
							if (img[i].fileType == 1) {
								this.imgurl = img[i].fileUrl
							}
						}
						this.infos = {
							prize: d.prize,
							head: d.babyInfo ? JSON.parse(d.babyInfo).imgUrl : "",
							achievementType: d.achievementType,
							img: img,
							transactionId: d.transactionId,
							title: d.name,
							slogan: d.synopsis,
							author: d.babyName,
							grandPrize: d.grandPrize,
							groupName: d.groupName,
							majorName: d.majorName,
							organization: d.institutionName || "暂无报名服务单位",
							time: d.addTime,
							activityId:d.activityId,
							activityName: d.activityName,
							recommendReason: d.recommendReason,
							province: d.province,
							likers: formatNumber(d.likeNum),
							email: d.email,
						};
						if (d.swCommentsWorksList&&d.swCommentsWorksList.length>0) {
							this.swipeList = d.swCommentsWorksList.map((e) => {
								return {
									content: e.comment,
									score: e.fraction
								};
							});
						}
						this.setScheduleList(d);
						this.end = true;
						this.shareReady();
					}
				});
			}
		},
		// 判断是否需要阅读码
		isSendEmail(sendEmailType, email, isSend) {
			if (sendEmailType === 0 && isSend === 1) {
				// 弹出
				if (email) {
					// 有邮箱
					this.hasEmail = true;
				} else {
					// 无邮箱
					this.hasEmail = false;
				}
				this.sendEmail = true;
			}
		},
		holdBack(a, b) {
			return b(this.close);
		},
		// 提交信息 0 我不需要 ； 1确定发送
		sendEmailHandle(type = 0) {
			if (type) {
				//
				sendReadingCode({
					id: this.id,
					sendEmailType: 2
				});
				this.sendEmail = false;
			} else {
				//
				if (!this.inpEmail && !this.infos.email) {
					this.$toast.fail("请输入邮箱");
					this.close = false;
					return;
				}
				const pass = this.validate.mail("inpEmail");
				if (!pass) {
					this.$toast.fail("邮箱格式不正确");
					this.close = false;
					return;
				}
				// 发送阅读码
				else
					sendReadingCode({
						id: this.id,
						email: this.infos.email || this.inpEmail,
						sendEmailType: 1
					}).then((res) => {
						if (res.success) {
							this.$root.$toast.success("阅读码已发送，请注意查收。");
							this.sendEmail = false;
							this.close = true;
						}
					});
			}
		},
		// 查看作品图片
		viewImage(img) {
			// eslint-disable-next-line
			// this.$root.$ImagePreview([img]);
			this.show = true;
			this.images = [img];
		},
		/**
		 * @description: 关闭音视频
		 * @param {*} index
		 * @author: wangxiaoheng
		 */
		beforeCloseHandler() {
			if (this.$refs.audioPlayer) {
				this.$refs.audioPlayer.pause();
				this.$refs.audioPlayer.currentTime = 0;
			}
			if (this.$refs.videoPlayer) {
				this.$refs.videoPlayer.pause();
				this.$refs.videoPlayer.currentTime = 0;
			}
		},
		//
		// downloadWorks() {
		//   // 非微信下载
		//   let url = this.images[0];
		//   let a = document.createElement("a");
		//   a.setAttribute("download", url);
		//   a.href = url;
		//   a.click();
		// },
		// 梳理参赛日程  (后端太懒他不想做)
		setScheduleList({
			addTime,
			swCommentsWorksList,
			stageType,
			worksType,
			channelSumitTime,
			activityType,
			achievementType,
			finalReleaseTime,
			prizeName,
			workScore,
			activityId
		}) {
			this.scheduleList = [];
			this.scheduleList.push({
				content: "提交成功",
				time: addTime
			});
			this.step++;
			this.scheduleList.push({
				content: "进入待评区",
				time: addTime
			});
			this.step++;
			if (stageType == 1 && activityType == 1) {
				this.scheduleList.push({
					content: "等待评选结果",
					time: channelSumitTime
				});
				this.step++;
			}
			if (achievementType == 2 && (activityType == 1 || activityType == 0)) {
					if(prizeName && prizeName == '无效参赛' || !prizeName){
						this.scheduleList.push({
							content: `${prizeName||'无效参赛'}`,
							time: finalReleaseTime,
							comment:workScore&&workScore.comment
						});
					}else{
						this.scheduleList.push({
							content: `${prizeName||'无效参赛'}`,
							time: finalReleaseTime,
						});
					}
				this.step++;
			}else if(achievementType == 2 && activityType==2){
				this.scheduleList.push({
					content: '评审结束',
					time: finalReleaseTime
				});
				this.step++;
				this.getAbilityProfile()
			} else if (worksType == 3) {
				this.scheduleList.push({
					content: `谢谢参与`,
					time: finalReleaseTime
				});
				this.step++;
			}
		},
		// 分享设置
		shareReady() {
			/* eslint-disable */
			wx.ready(() => {
				const infos = this.infos;
				let imgurl = this.imgurl;
				const href = window.location.href;
				const active = infos.activityName;
				wx.updateAppMessageShareData({
					title: infos.title, // 分享标题
					desc: `我参加了#${active}#，快来给我的作品点赞吧！`, // 分享描述
					link: href, // window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: imgurl, // 分享图标
					success: () => {
						// 设置成功
						// this.$root.$toast.success("设置成功！");
					},
					fail: (err) => {
						const followed = err.errMsg.indexOf(
							"the permission value is offline verifying"
						);
						if (followed > 0) {
							if (!this.mipLinkLoading) {
								this.$notify({
									type: "danger",
									message: "请检查是否关注该公众号"
								});
							}
							this.$root.$toast.fail("获取页面权限失败，请刷新页面后重试！");
						} else {
							this.$root.$toast.fail(JSON.stringify(err));
						}
					}
				});
				wx.updateTimelineShareData({
					title: infos.title, // 分享标题
					desc: `我参加了#${active}#，快来给我的作品点赞吧！`, // 分享描述
					link: href, //window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: imgurl, // 分享图标
					success: () => {
						// 设置成功
						// this.$root.$toast.success("设置成功！");
					},
					fail: (err) => {
						const followed = err.errMsg.indexOf(
							"the permission value is offline verifying"
						);
						if (followed > 0) {
							if (!this.mipLinkLoading) {
								this.$notify({
									type: "danger",
									message: "请检查是否关注该公众号"
								});
							}
							this.$root.$toast.fail({
								message: "获取页面权限失败，请刷新页面后重试！",
								duration: 2000,
								onClose: () => {
									this.refreshJSToken();
								}
							});
						} else {
							this.$root.$toast.fail({
								message: JSON.stringify(err),
								duration: 2000,
								onClose: () => {
									this.refreshJSToken();
								}
							});
						}
					}
				});
			});
			/* eslint-disable */
		},
		// wxlogin callback 微信登录回调
		wxLoginCallback() {
			const {
				id
			} = this.$route.query;
			let params = {};
			if (id) params.id = id;
			// 刷新页面js权限
			this.$root.mipLink("/player/photodetail", params);
		},
		// 检测用户是否点赞
		checkLike() {
			const openid = this.$store.state.openid;
			if (!openid) {
				return;
			}
			checkLikeWorks({
				worksId: this.id,
				openId: openid
			}).then((res) => {
				if (res.success) {
					this.isVisitor = !res.data.isBindTel;
				}
			});
		},
		// 能力画像
        getAbilityProfile(){
			AbilityProfile().then((res) => {
				if (res.success) {
					let data = res.data;
                    data.recommendCareerPath = data.recommendCareerPath.join('、');
					this.abilityProfileData = data;
					this.$nextTick(() => {
						this.initRadarChart();
					});
				}
			});
		},
		// 初始化 ECharts 雷达图
		initRadarChart() {
			const el = this.$refs.radarChart;
			if (!el) return;
			if (!this.radarChartInstance) {
				this.radarChartInstance = echarts.init(el);
			}
			this.radarChartInstance.setOption(this.radarOption, true);
		},
		// 窗口尺寸变化时重绘图表
		handleRadarResize() {
			if (this.radarChartInstance) {
				this.radarChartInstance.resize();
			}
		},
		// 保存能力画像为图片
		saveAbilityImage() {
			try {
				if (!this.radarChartInstance) {
					this.$toast && this.$toast.fail && this.$toast.fail('能力画像未就绪');
					return;
				}
				const url = this.radarChartInstance.getDataURL({
					type: 'png',
					pixelRatio: 2,
					backgroundColor: '#ffffff'
				});
				const a = document.createElement('a');
				a.href = url;
				a.download = '能力画像.png';
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				this.$toast && this.$toast.success && this.$toast.success('已保存');
			} catch (e) {
				console.error(e);
				this.$toast && this.$toast.fail && this.$toast.fail('保存失败');
			}
		}
	},
	mounted() {
		this.id = this.$route.query.id;
		this.role = this.$store.state.role;
		const code = this.$route.query.code;
		if (code) {
			this.mipLinkLoading = true;
		}
		const userInfo = this.$store.state.userInfo;
		this.isLogin = JSON.stringify(userInfo) !== "{}";
		if (this.isLogin) this.isVisitor = false;
		window.addEventListener('resize', this.handleRadarResize);
		this.getPageDetail();
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleRadarResize);
		if (this.radarChartInstance) {
			this.radarChartInstance.dispose();
			this.radarChartInstance = null;
		}
	}
};
</script>
<style lang="scss" scoped>
.detail-box-bg {
	position: relative;

	img {
		width: 100% !important;
		height: 238px !important;
		object-fit: cover;
	}

	.bottom-bg {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 64px;
		background: linear-gradient(180deg, rgba(248, 248, 249, 0) 0%, #F8F8F9 100%);
	}
}

.detail-box-panel {
	padding: 0 15px;
	padding-top: 15px;

	&.have-img {
		position: relative;
		margin-top: -50px;
		padding-top: 0;
	}
}

.detail-box {
	background: #FFFFFF;
	border-radius: 8px 8px 8px 8px;
	padding: 15px;
	margin-bottom: 15px;

	.detail-box-title {
		font-weight: bold;
		font-size: 17px;
		color: #222222;
		display: flex;
		align-items: center;

		img {
			width: 20px;
			margin-right: 5px;
		}
	}

	.detail-box-txt0 {
		.p1 {
			font-weight: bold;
			font-size: 23px;
			color: #333333;
			line-height: 27px;
		}

		.p2 {
			padding-top: 8px;

			span {
				background: rgba(255, 114, 70, 0.1);
				border-radius: 25px 25px 25px 25px;
				font-size: 12px;
				color: #FF7246;
				padding: 4px 10px;
				margin-right: 10px;
				font-weight: 400;
			}
		}

		.p3 {
			display: flex;
			align-items: center;
			font-weight: 400;
			font-size: 12px;
			color: #666666;
			padding-top: 15px;

			.item1 {
				flex: 1;
			}

			.item2 {
				width: 60%;

				img {
					width: 18px;
					height: 18px;
				}
			}

			.item1,
			.item2 {
				display: flex;
				// flex: 1;
				align-items: center;
			}

			img {
				width: 14px;
				height: 14px;
				margin-right: 2px;

			}
		}

		.p4 {
			padding-top: 15px;

			.idTab {
				display: flex;
				align-items: center;
				width: 315px;
				min-height: 35px;
				background: #f8f8f9;
				border-radius: 8px 8px 8px 8px;
				padding: 2px 10px;
				margin-bottom: 10px;
				font-size: 12px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				color: #666666;

				&:last-child {
					margin-bottom: 0;
				}

				.fileName {
					width: 250px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.idTab-div {
					width: 100%;
				}

				a {
					font-size: 12px;
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					color: #999999;
				}

				img {
					object-fit: contain;
					max-height: 210px;
					width: 100% !important;
					border-radius: 8px;
				}
			}
		}
	}

	.detail-box-txt1 {
		padding-top: 10px;
		font-weight: 400;
		font-size: 14px;
		color: #222222;
		line-height: 21px;
	}

	.detail-box-txt2 {
		margin-bottom: -10px;
		margin-top: 10px;

		.list {
			border-bottom: 1px solid #EEEEEE;
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			padding: 10px 0;

			&:last-child {
				border: none;
			}

			.p1 {
				margin-right: 5px;
				flex-shrink: 0;

				img {
					width: 19px;
					height: 19px;
				}
			}

			.p2 {
				font-weight: 400;
				font-size: 14px;
				color: #222222;
				line-height: 16px;
				flex: 1;
			}

			.p3 {
				font-size: 12px;
				color: #999999;
				flex-shrink: 0;
				margin-left: 5px;
			}

			// 无效参赛评语（单独一行）
			.p4 {
				width: 100%;
				margin-top: 8px;
				padding: 8px 10px;
				font-size: 13px;
				line-height: 22px;
				color: #666666;
				background: #f8f8f9;
				border-radius: 6px;

				.comment-label {
					color: #FF7246;
				}
			}
		}
	}

	.detail-box-txt3 {
		margin-bottom: -5px;
		margin-top: 10px;

		.list {

			display: flex;
			align-items: center;
			padding: 7px 0;

			.p2 {
				font-weight: 400;
				font-size: 14px;
				color: #666666;
				flex: 1;
			}

			.p3 {
				font-size: 14px;
				color: #222222;
			}
		}
	}

	// margin: 15px;
}

.photo-detail {
	// padding-bottom: 20px;
	height: 100vh;
	background: #F8F8F9;

	display: flex;
	flex-direction: column;

	.top {
		flex: 1;
		overflow-y: auto;
	}

	// .bottom{
	// 	height: 50px;
	// 	background-color: #fff;
	// }
	// padding: 15px;

	.page-wrap {
		.like-handle {
			display: flex;
			flex-direction: column;
			align-items: center;

			.author-infos-area {
				display: flex;
				flex-direction: column;
				align-items: center;

				img {
					width: 72px;
					height: 72px;
					border-radius: 36px;
				}

				div {
					line-height: 28px;
					font-size: 20px;
					color: #444;
					margin-top: 12px;
				}

				p {
					font-size: 16px;
					color: #999;
					line-height: 22px;
					margin-top: 8px;
				}

				span {
					display: flex;
					margin-top: 16px;

					img {
						margin-right: 8px;
						height: 22px;
						width: 16px;
					}

					font-size: 16px;
					line-height: 22px;
				}
			}

			.link-btn {
				margin-top: 30px;
				width: 141px;
				height: 37px;
				background: #ffffff;
				box-shadow: 0px 3px 6px rgba(5, 75, 27, 0.2);
				border-radius: 19px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 16px;
				color: #333;

				&.ed {
					background: #eee;
				}
			}
		}
	}

	.works-dowanload {
		position: fixed;
		height: 52px;
		width: 52px;
		left: 161.5px;
		bottom: 80px;

		img {
			width: 100%;
			height: 100%;
		}
	}

	// background-color: #f2f2f2;
	width: 100%;
	max-width: 10rem;
	text-align: left;

	.infos {
		min-height: 190px;
		background-color: #fff;
		margin: 50px 20px;
		margin-bottom: 22px;
		width: 335px;
		display: flex;
		box-shadow: 0px 2px 5px rgba(5, 75, 27, 0.2);
		border-radius: 8px;
		max-height: 190px;

		.thumbnail {
			position: relative;
			width: 135px;
			height: 190px;
			overflow: hidden;
			border-radius: 15px;
			margin-top: -15px;
			background: #000;
			margin-left: -10px;
			display: flex;
			align-items: center;
			justify-content: center;

			img {
				height: 120%;
				position: absolute;
			}

			.act-name {
				height: 30px;
				line-height: 15px;
				color: #fff;
				font-size: 12px;
				position: absolute;
				bottom: 0;
				width: 100%;
				padding: 10px;
			}
		}

		.photo-info {
			flex: 1;
			max-width: 210px;
			margin-left: 10px;
			display: flex;
			flex-direction: column;
			position: relative;

			.title {
				width: 100%;
				margin-top: 12px;

				.tit {
					font-size: 18px;
					font-weight: 900;
					color: #666;
					line-height: 24px;
					width: 190px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;

					img {
						width: 14px;
						height: 14px;
						margin-right: 18px;
					}
				}

				.slogan {
					width: 100%;
					position: relative;

					div {
						font-size: 12px;
						margin: 5px 0;
						color: #999;
						line-height: 20px;
						max-width: 80%;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

					// display: -webkit-box;
					// -webkit-line-clamp: 2;
					// -webkit-box-orient: vertical;
					// display: -moz-box;
					// -moz-line-clamp: 2;
					// -moz-box-orient: vertical;
					// word-wrap: break-word;
					// word-break: break-all;
					// white-space: normal;
					&::before {
						content: "";
						position: absolute;
						z-index: 1;
						height: 100%;
						width: 10px;
						display: block;
						background: url("../../assets/images/active/icon-right-arr.png");
						background-size: 10px 10px;
						background-position: center center;
						background-repeat: no-repeat;
						top: 0;
						right: 15px;
					}
				}

				// border-bottom: 1px solid #f2f2f2;
			}

			.author {
				flex: 1;
				max-height: 94px;
				line-height: 24px;
				font-size: 12px;
				color: #999999;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.ator-info {
					display: flex;
					flex-wrap: wrap;
					max-height: 53px;
					overflow: hidden;

					span {
						padding: 0 5px;
						background-color: #f2f2f2;
						color: #000;
						font-size: 12px;
						display: block;
						margin-right: 8px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						border-radius: 5px;
						max-height: 24px;

						&:nth-child(1) {
							margin-bottom: 5px;
						}

						&:nth-child(2) {
							margin-bottom: 5px;
						}
					}
				}

				.org {
					max-width: 180px;

					p {
						max-width: 180px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						line-height: 20px;
					}
				}

				.time {}
			}

			.browse-infos {
				display: flex;
				justify-content: space-between;
				align-items: center;
				bottom: 0;
				width: 100%;
				padding-right: 10px;

				.likers {
					display: flex;
					align-items: center;
					line-height: 20px;

					img {
						width: 10px;
						height: 11px;
					}

					span {
						font-size: 14px;
						color: #666666;
						margin-left: 10px;
					}
				}

				.last-liker {
					width: 120px;
					display: flex;
					flex-direction: row-reverse;
					align-items: center;

					.heads {
						display: flex;
						align-items: center;

						img {
							width: 16px;
							height: 16px;
							border-radius: 8px;
						}
					}

					span {
						margin-left: 5px;
						font-size: 12px;
						color: #c8c8c8;
					}
				}

				.share {
					font-size: 12px;
					width: 64px;
					height: 30px;
					border-radius: 32px;
					display: flex;
					align-items: center;
					justify-content: center;
					color: #fff;
					background-image: linear-gradient(-90deg,
							rgba(55, 220, 141, 1) -15%,
							rgba(30, 191, 95, 1) 100%);
				}
			}
		}
	}

	.reason {
		padding: 10px 20px;
		padding-top: 0;
		max-width: 10rem;
		width: 100%;
		background-color: #fff;

		.reason-tips {
			width: 214px;
			height: 210px;
			background-image: url("../../assets/images/home/grand-prize-ico.png");
			background-size: 100% 100%;
			background-position: center center;
			background-repeat: no-repeat;
			color: #fff;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 12px;
			margin: 0 auto;
		}

		.reason-content {
			position: relative;
			// &::before {
			//   content: "推荐理由";
			//   height: 26px;
			//   border-radius: 5px;
			//   color: #fff;
			//   font-size: 12px;
			//   line-height: 0px;
			//   width: 62px;
			//   position: absolute;
			//   top: 0;
			//   left: 0;
			//   background-color: #16d77a;
			//   text-align: right;
			//   display: flex;
			//   align-items: center;
			//   justify-content: center;
			//   text-indent: 0;
			// }
			margin-top: 12px;
			// text-indent: 66px;
			font-size: 12px;
			padding: 8px 12px;
			line-height: 26px;
			color: #666;
			background-color: #f2f2f2;
			border-radius: 8px;
		}
	}

	.remark {
		margin-top: 10px;
		padding: 10px 0px;
		max-width: 10rem;
		width: 100%;
		background-color: #fff;

		.remark-title {
			padding: 0px 20px;
		}

		.remark-swipe {
			height: 170px;
			width: 375px;

			.my-swipe {
				height: 100%;
				width: 100%;
			}

			.remark-item {
				height: 130px;
				background-color: #f9f9f9;
				border-radius: 10px;
				padding: 8px 12px;
				width: 335px;
				margin: 0 20px;
				overflow: hidden;
				position: relative;
				display: flex;

				.score {
					padding: 15px;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;

					p {
						color: #16d77a;
						// font-size: 16px;
						// margin: 0 5px;
						font-size: 53px;
						color: #ff635a;
						position: relative;

						&:after {
							content: "分";
							position: absolute;
							bottom: 10px;
							color: #999999;
							right: -15px;
							font-size: 14px;
						}
					}

					div {
						line-height: 20px;
						color: #999999;
						margin-top: 4px;
						font-size: 14px;
					}

					span {
						display: block;
						height: 1px;
						width: 36px;
						background-color: #16d77a;
					}
				}

				.remark-content {
					width: 220px;
					font-size: 12px;
					line-height: 22px;
					color: #666666;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 5;
					-webkit-box-orient: vertical;
					display: -moz-box;
					-moz-line-clamp: 5;
					-moz-box-orient: vertical;
					word-wrap: break-word;
					word-break: break-all;
					white-space: normal;
				}
			}
		}
	}

	.schedule {
		margin-top: 10px;
		padding: 10px 20px;
		max-width: 10rem;
		width: 100%;
		background-color: #fff;

		.schdl-item {
			min-width: 140px;

			div {}

			p {}
		}
	}

	.photo-view {
		padding: 0px 20px;
		max-width: 10rem;
		width: 100%;
		background-color: #fff;
		margin-bottom: 30px;

		div {
			img {
				width: 100%;
			}
		}
	}

	.van-overlay {
		z-index: 10;
		display: flex;
		justify-content: center;
		align-items: center;

		.share-box {
			position: absolute;
			height: 273px;
			width: 351px;
			background: #fff;
			background: #fff;
			border-radius: 16px;
			padding: 15px 0;
			bottom: 74px;
			left: 12px;
			overflow: hidden;
			display: flex;
			flex-direction: column;

			.infos-area {
				padding: 0 15px;
				height: 118px;
				display: flex;

				img {
					width: 122px;
					height: 102px;
					border-radius: 8px;
				}

				div {
					width: 158px;
					font-size: 16px;
					margin-left: 20px;
					color: #333;
					line-height: 22px;
					text-align: justify;
					text-align-last: left;
				}
			}

			.share-area {
				display: flex;
				flex: 1;
				justify-content: space-between;
				padding: 0 25px;
				align-items: center;

				img {
					height: 82px;
					width: 82px;
				}
			}

			.cancel-btn {
				height: 40px;
				text-align: center;
				line-height: 52px;
				font-size: 16px;
				color: #999;
				border-top: 1px solid #999;
			}
		}
	}

	.tips-content {
		width: 80%;
		margin: 0 auto;
		font-size: 14px;
		color: #999;
		margin-bottom: 10px;

		p {
			margin: 10px 0;
		}

		input {
			border: 1px solid #aaa;
			width: 100%;
		}
	}
}

.van-popup.photo-tags {
	background-color: unset;

	.checkClass {
		width: 8.1067rem;
		border-radius: 0.4267rem;
		overflow: hidden;
		margin-top: 5vh;
		display: flex;
	}

	.show-photo-tags {
		height: 100%;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		overflow: hidden;

		p {
			font-size: 14px;
			text-align: center;
			color: #f2f2f2;
		}

		img {
			width: 275px;
			border-radius: 16px;
			overflow: hidden;
			margin-top: 2vh;
			display: flex;
		}
	}
}

/* 学生艺术综合素养能力画像 */
.ability-profile {
	padding-top: 4px;

	.ap-header {
		display: flex;
		align-items: center;
		font-weight: bold;
		font-size: 17px;
		color: #222;
		margin-bottom: 6px;
	}

	.ap-icon {
		width: 22px;
		height: 22px;
		border-radius: 50%;
		background: #BFE5FF;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 6px;
		flex-shrink: 0;
		position: relative;

		&::before {
			content: "";
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background: #4FB4F0;
			position: absolute;
			top: 4px;
			left: 4px;
		}

		&::after {
			content: "";
			position: absolute;
			bottom: 4px;
			right: 4px;
			width: 0;
			height: 0;
			border-left: 5px solid transparent;
			border-right: 5px solid transparent;
			border-bottom: 8px solid #4FB4F0;
			transform: rotate(35deg);
		}
	}

	.ap-title {
		font-size: 17px;
		font-weight: 600;
		color: #222;
	}

	.ap-chart {
		width: 100%;
		height: 280px;
		margin: 6px auto 0;
	}

	.ap-recommend {
		display: inline-block;
		background: #E8F8EE;
		color: #2BB673;
		font-size: 12px;
		padding: 4px 12px;
		border-radius: 20px;
		margin: 10px auto 0;
		text-align: left;
	}

	.ap-save {
		width: 130px;
		height: 36px;
		line-height: 36px;
		text-align: center;
		background: linear-gradient(90deg, #4DD68A, #34C77B);
		color: #fff;
		font-size: 14px;
		border-radius: 22px;
		margin: 14px auto 0;
		cursor: pointer;
		box-shadow: 0 2px 6px rgba(52, 199, 123, 0.25);
	}

	.ap-growth {
		margin-top: 16px;
		padding-top: 14px;
		border-top: 1px solid #F0F0F0;

		.ap-growth-title {
			font-size: 15px;
			font-weight: 600;
			color: #333;
			margin-bottom: 10px;
		}

		.ap-growth-list {
			display: flex;
			flex-direction: column;
		}

		.ap-growth-item {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 6px 0;
			font-size: 14px;
		}

		.ap-growth-name {
			color: #666;
		}

		.ap-growth-val {
			color: #2BB673;
			font-weight: 600;
		}
	}
}

.diy-cert-box {
	.detail-box-diy {
		display: flex;
		align-items: center;
		padding: 12px 4px 0;

		.diy-icon {
			width: 44px;
			height: 44px;
			border-radius: 22px;
			background: linear-gradient(135deg, #67c23a, #5dd682);
			display: flex;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;

			&::before {
				content: "DIY";
				color: #fff;
				font-weight: bold;
				font-size: 14px;
				letter-spacing: 1px;
			}
		}

		.diy-text {
			flex: 1;
			margin-left: 12px;

			.diy-title {
				font-size: 16px;
				font-weight: 600;
				color: #222;
				line-height: 22px;
			}

			.diy-desc {
				font-size: 12px;
				color: #999;
				line-height: 18px;
				margin-top: 4px;
			}
		}

		.diy-arrow {
			font-size: 24px;
			color: #ccc;
			line-height: 1;
			margin-left: 8px;
		}
	}
}
</style>
<style lang="scss">
.photo-detail {
	.van-popup.slogan {
		border-radius: 20px 20px 0 0;
		overflow-y: hidden;

		.van-icon {
			right: calc((100% - 16px) / 2);
			font-size: 16px;

			&::after {
				content: "";
				position: absolute;
				left: -3px;
				top: -3px;
				height: 20px;
				width: 20px;
				box-sizing: content-box;
				border: 1px solid #c8c9cc;
				border-radius: 50%;
			}
		}
	}

	.info-wrap {
		margin-top: 50px;
		padding: 0 20px;
		height: 100%;
		overflow-y: scroll;

		.intro {
			margin-top: 20px;
			line-height: 24px;
			font-size: 14px;
			color: #999;
			padding-bottom: 80px;
		}
	}
}
</style>